import {createFeatureSelector, createSelector} from '@ngrx/store';
import {EmbeddingState} from './embedding.reducer';
import {PaperHasEmbeddingDTO} from '../dto/embedding';
import {selectQueryParam} from '../../../utils/services/router.selectors';

export const selectEmbeddingState = createFeatureSelector<EmbeddingState>('embeddings');

export const selectProjectEmbeddings = (projectId: number) => createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.projectEmbeddings[projectId] || []
);

export const selectPaperHasEmbeddings = (projectId: number) => createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.paperHasEmbeddings[projectId] || []
);

export const selectQueryPaperHasEmbedding = (projectId: number) => createSelector(
  selectPaperHasEmbeddings(projectId),
  selectQueryParam("paper"),
  (papers: PaperHasEmbeddingDTO[], paperId) => paperId ? papers.filter(p => p.paperId === +paperId).shift() || undefined : undefined
);

export const selectProjectEmbeddingsOverview = (projectId: number) => createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.projectEmbeddingsOverview[projectId] || null
);

export const selectPaperHasEmbeddingsCount = (projectId: number) => createSelector(
  selectPaperHasEmbeddings(projectId),
  (state: PaperHasEmbeddingDTO[]) => state.filter(p => p.hasEmbedding).length || 0
);

export const selectPaperHasEmbeddingsTotal = (projectId: number) => createSelector(
  selectPaperHasEmbeddings(projectId),
  (state: PaperHasEmbeddingDTO[]) => state.length || 0
);


export const selectPaperEmbeddings = (paperId: number) => createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.paperEmbeddings.filter(embedding => embedding.paperId === paperId)
);

export const selectEmbeddingLoading = createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.loading
);

export const selectEmbeddingError = createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.error
);

export const selectPaperHasEmbeddingCreated = (paperId: number) => createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.checkPaperHasEmbeddings[paperId] || undefined
);

export const selectEmbeddingAugmentorResults = createSelector(
  selectEmbeddingState,
  (state: EmbeddingState) => state.embeddingAugmentorResults
);
